import { SubscribeQuery } from '@/queries';

const getAll = (retailerId: string, campaignId: string): SubscribeQuery => ({
  className: 'URLShortner',
  where: {
    retailer: {
      __type: 'Pointer',
      className: 'Retailer',
      objectId: retailerId,
    },
    campaign: {
      __type: 'Pointer',
      className: 'Campaign',
      objectId: campaignId,
    },
  },
});

const ShortLinkQueries = {
  getAll,
};

export default ShortLinkQueries;
